module.exports = __webpack_public_path__ + "img/todo-empty.5b1f2ee0.png";